import React, { Component, useState } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function FooterMobile(props) {
  const currentYear = new Date().getFullYear();
  const [open, setOpen] = useState(false);
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;


   const handleClick = () => {
       let bool = !open;
       setOpen(bool);

       props.handleMenuClick(bool);
   }

    return (

      <div>


              <div style={{textAlign: 'center', color: '#fff', fontSize: '1.1rem'}}>{`Restez connecté(e) à la dynamique:`}</div>


              <div style={{clear: 'both', height: '10px'}}/>

              <div style={{textAlign: 'center', color: '#fff', fontSize: '0.8rem'}}>
                  <a href="/newsletter" style={{color:'#a7c7fa'}}>{`Abonnez-vous à notre newsletter`}</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a href="https://whatsapp.com/channel/0029VbApiLj6BIEa4sh5Z92F" target="_blank" style={{color:'#a7c7fa'}}>{`Rejoignez notre groupe WhatsApp`}</a>
              </div>

              <div style={{clear: 'both', height: '100px'}}/>


              <div style={{textShadow: '1px 1px 2px rgba(0, 0, 0,1)', fontSize: '14px'}}>
                {i18n.language == 'en' &&
                   <div style={{textAlign: 'center', color: '#fff'}}>
                       <div>{`< Re > RDC · v${global.version} ·`} · © {currentYear}</div>
                       <div>This website is powered by <a href="https://www.debyoo.com" target="_blank" style={{color: '#fff'}}>Debyoo</a></div>
                  </div>
                }

                {i18n.language == 'fr' &&
                   <div style={{textAlign: 'center', color: '#fff'}}>
                       <div>{`< Re > RDC · v${global.version} ·`} © {currentYear}</div>
                       <div>Ce site est propulsé par <a href="https://www.debyoo.com" target="_blank" style={{color: '#fff'}}>Debyoo</a></div>
                  </div>
                }
              </div>

              <div style={{clear: 'both', height: '20px'}}/>

      </div>

    )

}
